import { IconButton } from "@mui/material";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { formatString } from "../../../common";
import ConfirmDialog from "../../../common/components/ConfirmDialog";
import IconComponent from "../../../common/components/IconComponent";
import { IExpressionEvaluatorContext } from "../../../ExpressionsModule/Models/IExpressionEvaluatorContext";
import { TableColumnActionModel } from "../../Models/TableModel";

type PanelActionProps = {
  actions: TableColumnActionModel[];
  size?: "small" | "medium" | "large";
  formatData?: any;
  context?: IExpressionEvaluatorContext;
};

const PanelAction: React.FC<PanelActionProps> = ({ actions, size = "medium", formatData, context }) => {
  const [openDialogIndex, setOpenDialogIndex] = useState<number | null>(null);
  const [isExecuting, setIsExecuting] = useState(false);

  const handleActionClick = async (action: TableColumnActionModel, index: number) => {
    if (!action.OnSelected || !context) return;

    if (action.ConfirmationDialog) {
      setOpenDialogIndex(index);
    } else {
      await executeAction(action);
    }
  };

  const executeAction = async (action: TableColumnActionModel) => {
    if (!action.OnSelected || !context) return;

    setIsExecuting(true);
    try {
      await context.Evaluator.evaluate(action.OnSelected, context);
    } finally {
      setIsExecuting(false);
    }
  };

  const handleConfirm = async (action: TableColumnActionModel) => {
    await executeAction(action);
    setOpenDialogIndex(null);
  };

  const handleCancel = () => {
    setOpenDialogIndex(null);
  };

  return (
    <>
      {actions.map((action, index) => {
        const path = action.Path && formatData ? formatString(action.Path, formatData) : action.Path;
        const hasOnSelected = !!action.OnSelected;
        const shouldRenderLink = path && !hasOnSelected;
        const shouldRenderButton = !path && hasOnSelected;

        const button = (
          <IconButton title={action.Label} size={size} onClick={hasOnSelected ? () => handleActionClick(action, index) : undefined} disabled={isExecuting}>
            <IconComponent iconName={action.IconName} size={size} />
          </IconButton>
        );

        if (shouldRenderLink) {
          return (
            <Link key={index} to={path!} style={{ textDecoration: "none" }}>
              {button}
            </Link>
          );
        }

        if (shouldRenderButton) {
          return <React.Fragment key={index}>{button}</React.Fragment>;
        }

        return null;
      })}

      {actions.map((action, index) => {
        if (action.ConfirmationDialog && openDialogIndex === index) {
          return (
            <ConfirmDialog
              key={`dialog-${index}`}
              open={true}
              title={action.ConfirmationDialog.Title}
              message={action.ConfirmationDialog.Message}
              onConfirm={() => handleConfirm(action)}
              onCancel={handleCancel}
              isLoading={isExecuting}
            />
          );
        }
        return null;
      })}
    </>
  );
};

export default PanelAction;
